import { render, staticRenderFns } from "./BillingHistoryCard.vue?vue&type=template&id=62181916&scoped=true&"
import script from "./BillingHistoryCard.vue?vue&type=script&lang=js&"
export * from "./BillingHistoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62181916",
  null
  
)

export default component.exports